import { Plugin } from "@ckeditor/ckeditor5-core";
import { ButtonView } from "@ckeditor/ckeditor5-ui";
import { CKEditorError } from "@ckeditor/ckeditor5-utils";

import { INSERT_SYMBOL_COMMAND } from "./symbols";

export default class SymbolShortcutsUI extends Plugin {
  static get pluginName() {
    return "SymbolShortcutsUI";
  }

  init() {
    const symbols = this.editor.config.get("symbolShortcuts.items");

    // SymbolShortcutsEditing defines the default in its constructor, so a
    // missing or malformed list means the configuration was overridden with a
    // bad value. Failing here is better than registering no buttons at all:
    // CKEditor drops the unknown toolbar item names but keeps the separator
    // preceding them, which would leave a dangling divider on the toolbar.
    if (!Array.isArray(symbols)) {
      throw new CKEditorError(
        "symbol-shortcuts-invalid-items: The `symbolShortcuts.items` configuration must be an array of symbol definitions.",
        this.editor,
        { items: symbols },
      );
    }

    symbols.forEach((symbol) => this._addSymbolButton(symbol));
  }

  /**
   * Registers one toolbar button for a configured symbol. The button renders
   * the symbol itself as its label so content specialists can tell the four
   * quote marks apart at a glance.
   */
  _addSymbolButton({ name, character, label }) {
    const editor = this.editor;
    const t = editor.t;

    editor.ui.componentFactory.add(name, (locale) => {
      const command = editor.commands.get(INSERT_SYMBOL_COMMAND);
      const buttonView = new ButtonView(locale);

      buttonView.set({
        class: "ck-symbol-shortcut",
        label: character,
        tooltip: t(label),
        withText: true,
      });

      buttonView.bind("isEnabled").to(command, "isEnabled");

      buttonView.on("execute", () => {
        editor.execute(INSERT_SYMBOL_COMMAND, { character });
        editor.editing.view.focus();
      });

      return buttonView;
    });
  }
}
